var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.selected,"placeholder":_vm.plc || 'Номер Амбулаторной карты',"filterable":"","disabled":""},on:{"input":_vm.dispatch}})
}
var staticRenderFns = []

export { render, staticRenderFns }